import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import NotificationAsk from 'components/Notification/NotificationAsk';
import NotificationFixedTop from 'components/Notification/NotificationFixedTop';
import moment from 'moment';
import { IconButton, Tooltip, Dialog } from '@material-ui/core';
import { createTenantName } from './TREntriesLogic';
import { Close } from '@material-ui/icons';
import Loader from '../../../components/Loader/Loader';

const TREntriesList = (props) => {
    const [delay, setDelay] = useState(false);
    const [showURL, setShowURL] = useState(null);
    const [askBeforeDelete, setAskBeforeDelete] = useState(null);
    const [startDelete, setStartDelete] = useState(false);
    const [notificationFixedTop, setNotificationFixedTop] = useState('');
    const { data } = props;
    console.log('data', data)
    const final_data = data ? data.map((l, key) => { // map users to table rows
        const dat = l.data;
        const tenants = dat.tenants ? dat.tenants.map(dt => {
            return createTenantName(dt);
        }).join(', ') : '';

        return ({
            id: l.id,
            tenants,
            project_name: l.project_name,
            date: moment(l.created_date.replace('T',' ')).subtract(8, 'hours').format("MM/DD/YYYY h:mm a"),
            username: l.name,
            actions: <div>
                {(props.tab !== 'pending_final_signature' && 
                props.tab !== 'pending_signature' && 
                props.tab !== 'my_completed' &&
                props.tab !== 'all_completed'
                ) && <IconButton onClick={() => {
                    props.openEntry(l);
                }}>
                    <i className="fa fa-edit"></i>
                </IconButton>}

                {(props.tab === 'pending_signature' || 
                props.tab === 'my_completed' ||
                props.tab === 'all_completed'
                ) && <IconButton onClick={() => {
                    props.openEntry(l);
                }}>
                    <i className="fa fa-eye"></i>
                </IconButton>}

                {props.tab === 'pending_final_signature' && <Tooltip title="Sign Tenant Rep Agreement" placement="top">
                    <IconButton
                        onClick={() => {
                            props.getTrSigningUrl(l.id);
                            setShowURL(true);
                        }}
                    >
                        <i className="fa fa-edit font-22"></i>
                    </IconButton>
                </Tooltip>}

                {props.tab === 'my_drafts' && <IconButton
                    onClick={() => {
                        setAskBeforeDelete(l);
                    }}
                >
                    <i className="fa fa-trash"></i>
                </IconButton>}
            </div>
        })
    }) : [];

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Tenants",
            accessor: "tenants"
        },
        {
            Header: "Date",
            accessor: "date"
        },
        {
            Header: "Submitter",
            accessor: "username"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    useEffect(() => {
        if (props.success_delete && startDelete) {
            setNotificationFixedTop('Entry deleted');
            props.reload();
            setStartDelete(false);
        }
        if (props.error_delete && startDelete) {
            setNotificationFixedTop('There was an error deleting the entry, please contact support if the issue persists.')
            setStartDelete(false);
        }
    }, [props.success_delete, props.error_delete]);

    return (
        <div className="table-adjust2">
            <ReactTable 
                filterable
                className='-striped -highlight' 
                showPaginationTop 
                showPaginationBottom 
                resizable={false} 
                defaultPageSize={10} 
                pageSizeOptions={[10, 20, 30]}
                sorted={[
                    {
                     id: 'id',
                     desc: true
                    }
                ]}
                data={final_data} 
                columns={columns}
            />

            {askBeforeDelete && <NotificationAsk 
                title="Are you sure?"
                message="Do you want to delete this Tenant Rep entry?"
                open={askBeforeDelete ? true : false}
                close={() => {
                    setAskBeforeDelete(null);
                }}
                success={() => {
                    setStartDelete(true);
                    props.deleteTrEntry(askBeforeDelete.id);
                    setAskBeforeDelete(null);
                }}
            />}

            {notificationFixedTop && <NotificationFixedTop 
                message={notificationFixedTop}
                autoClose={4000}
                close={() => {
                    setNotificationFixedTop('');
                }}
            />}

            {
                <Dialog
                    fullWidth={true}
                    maxWidth={false}
                    open={showURL ? true : false}
                    onClose={() => {
                        setTimeout(() => {
                            props.reload();
                            setShowURL(false);
                        }, 500);
                    }}
                >
                    <div
                        className="close-btn mt-20 mb-20"
                        onClick={() => {
                            setDelay(true);
                            setTimeout(() => {
                                window.location.href = "/tr?s=pending_final_signature";
                            }, 10000);
                        }}
                    >
                        <Close />
                    </div>
                    {!props.signing_url && !delay && <div style={{margin:'0 auto'}}>
                            <Loader />
                        </div>}
                    {delay && (
                        <div style={{margin:'0 auto'}}>
                            <Loader />
                            Checking status, please refresh as needed if records have not updated.
                        </div>
                    )}
                    {!delay && (
                        <iframe
                            src={props.signing_url}
                            style={{
                                width: "100%",
                                height: 900,
                                overflow: "scroll",
                            }}
                        ></iframe>
                    )}
                </Dialog>
            }
        </div>
    )
}

export default TREntriesList;